export default __webpack_public_path__ + "static/media/Check.d787c276.svg";